module.exports = __webpack_public_path__ + "img/gs03.3115995e.jpg";